"use client";

import { InfoGroup } from "#/components/InfoGroup/InfoGroup";

import { useOptionPortfolioImpactAndGreeksController } from "./OptionPortfolioImpactAndGreeks.controller";

export interface PortfolioImpactAndGreeksProps {
  isTradeConfirmation?: boolean;
}

export const PortfolioImpactAndGreeks: React.FC<
  PortfolioImpactAndGreeksProps
> = ({ isTradeConfirmation = false }) => {
  const { isValid, marginData, greeksData, isLoading, isMissingDetails } =
    useOptionPortfolioImpactAndGreeksController();

  if (isMissingDetails || !isValid) return null;

  return (
    <div className="mt-2 w-full">
      <InfoGroup
        variant="normal"
        rows={marginData}
        isLoading={isLoading}
        title="Portfolio Impact"
      />
      <InfoGroup
        isGreek
        rows={greeksData}
        isLoading={isLoading}
        title="Portfolio Greeks"
        variant={isTradeConfirmation ? "normal" : "expandable"}
      />
    </div>
  );
};
